import { Typography } from '@altibox/design-system-component-lib';
import React, { FunctionComponent, ReactNode } from 'react';

import { Image, ImageProps } from 'app/components/image';

import { StyledImageContainer, StyledButton, StyledInnerContainer } from './choose-button.styled';

interface OwnProps {
    title: ReactNode;
    items: SelectButtonItem[];
    onClick: () => void;
}

export interface SelectButtonItem {
    icon: ImageProps;
    text: string;
    isValueSensitive?: boolean;
}

type Props = OwnProps;

const ChooseButton: FunctionComponent<Props> = (props) => {
    const { title, items, onClick } = props;

    return (
        <StyledButton onClick={onClick}>
            {title}
            {items.map((item, index) => (
                <StyledInnerContainer key={index}>
                    <StyledImageContainer>
                        <Image {...item.icon} />
                    </StyledImageContainer>
                    <Typography variant="paragraph3" component="p" data-hj-suppress={item.isValueSensitive}>
                        {item.text}
                    </Typography>
                </StyledInnerContainer>
            ))}
        </StyledButton>
    );
};

export { ChooseButton };
